import { Box, Grid, Theme, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { FnolQuestionTypes } from '../../../model/create-draft-claim-request';

const ProgressBar = (props: any) => {
  const theme: Theme = useTheme();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (props.currentStepName === FnolQuestionTypes.INSURED_CONTACT_TYPE) {
      setProgress(98);
    } else if (props.currentStepName === FnolQuestionTypes.END) {
      setProgress(99);
    } else if (props.currentAnswered === 0) {
      setProgress(0);
    } else {
      const initialBackoff = 1 / 7;
      let percentageDone = initialBackoff;

      for (let i = 1; i < props.currentAnswered; i++) {
        percentageDone += (1 - percentageDone) * initialBackoff;
      }
      setProgress(percentageDone * 100);
    }
  }, [props.currentAnswered]);

  return (
    <Box title="progressBar">
      <Grid>
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: theme.custom.styles.progressBar.statusBarsProgressText,
            }}
          >
            <b>Completed: {Math.round(progress)}%</b>
          </Typography>
        </div>

        <div
          style={{
            borderRadius: theme.custom.styles.borderRadius.radiusProgressBar,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: theme.custom.styles.progressBar.borderColor,
            backgroundColor: theme.custom.styles.progressBar.backgroundColor,
          }}
        >
          <div
            style={{
              borderRadius: theme.custom.styles.borderRadius.radiusProgressBar,
              height: '1em',
              width: progress + '%',
              backgroundColor: theme.custom.styles.progressBar.fillColor,
            }}
          ></div>
        </div>
      </Grid>
    </Box>
  );
};

export default ProgressBar;
